/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum GrantTypes {
    Password = 'password',
    Mfa = 'mfa',
    RefreshToken = 'refresh_token',
    AuthorizationCode = 'authorization_code',
    PublicKey = 'public_key',
}
